import { MetricsContext } from './MetricsContext.js';
import { jsx } from '@emotion/react/jsx-runtime';

function MetricsProvider(_ref) {
  let {
    children,
    metrics
  } = _ref;
  return jsx(MetricsContext.Provider, {
    value: metrics,
    children: children
  });
}

export { MetricsProvider };
//# sourceMappingURL=MetricsProvider.js.map
